import Input from '@/common/components/Input';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import React from 'react';
import { mapInputsToAddressEE } from './mapInputsToAddressEE';

const InputsEE = ({ addressFormInputs, handleChangeInputValue }) => {
	const { translation } = useTranslationContext();

	return (
		<>
			<Input
				margin='6px'
				name={translation.addressLine1}
				width={120}
				inputWidth={260}
				value={addressFormInputs.addressLine1}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('addressLine1', e)}
			/>
			<Input
				margin='6px'
				name={translation.addressLine2}
				width={120}
				inputWidth={260}
				value={addressFormInputs.addressLine2}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('addressLine2', e)}
			/>
			<Input
				margin='6px'
				name={translation.cityTownVillage}
				width={120}
				inputWidth={260}
				value={addressFormInputs.city}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('city', e)}
			/>
			<Input
				margin='6px'
				name={translation.postalCode}
				width={120}
				inputWidth={260}
				value={addressFormInputs.postalCode}
				requiredSign
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('postalCode', e)}
			/>
			<Input
				margin='6px'
				name={translation.district}
				width={120}
				inputWidth={260}
				value={addressFormInputs.district}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('district', e)}
			/>
			<Input
				margin='6px'
				name={translation.municipality}
				width={120}
				inputWidth={260}
				value={addressFormInputs.municipality}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('municipality', e)}
			/>
			<Input
				margin='6px'
				name={translation.county}
				width={120}
				inputWidth={260}
				value={addressFormInputs.county}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('county', e)}
			/>
			<Input
				margin='6px'
				name={translation.phone_number_for_courier}
				width={120}
				inputWidth={260}
				value={addressFormInputs.phoneForCourier}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('phoneForCourier', e)}
			/>
			<Input
				margin='6px'
				name={translation.courierInfo}
				width={120}
				inputWidth={260}
				value={addressFormInputs.additionalInfo}
				placeholder=''
				controlled={true}
				onChange={(e) => handleChangeInputValue('additionalInfo', e)}
			/>
			<div
				style={{
					marginTop: '18px',
				}}
			>
				<span
					style={{
						fontWeight: 'bold',
						marginRight: '12px',
					}}
				>
					{translation.address}:
				</span>
				<span>{mapInputsToAddressEE(addressFormInputs)}</span>
			</div>
		</>
	);
};

export default InputsEE;
